<template>
    <div class="loader">   
        <div v-if="loaderStyle == 'bullets'">
            <svg width="55px"  height="55px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-ellipsis" style="background: none;"><!--circle(cx="16",cy="50",r="10")--><circle cx="84" cy="50" r="0" :fill="circleColor"><animate attributeName="r" values="10;0;0;0;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="0s"></animate><animate attributeName="cx" values="84;84;84;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="0s"></animate></circle><circle cx="16" cy="50" r="9.13238" :fill="circleColor"><animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate><animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate></circle><circle cx="84" cy="50" r="0.867619" :fill="circleColor"><animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate><animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate></circle><circle cx="81.0501" cy="50" r="10" :fill="circleColor"><animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="0s"></animate><animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="0s"></animate></circle><circle cx="47.0501" cy="50" r="10" :fill="circleColor"><animate attributeName="r" values="0;0;10;10;10" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="0s"></animate><animate attributeName="cx" values="16;16;16;50;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="1s" repeatCount="indefinite" begin="0s"></animate></circle></svg>
        </div> 
        <div v-else-if="loaderStyle == 'circle'">
            <div class="lds-css ng-scope">
                <div style="width:100%;height:100%" class="lds-eclipse">
                    <div :style="{
                        'boxShadow': `0 8px 0 0 ${circleColor}`
                    }"></div>
                </div>
                <span :style="{color: textColor}">{{loaderMessage}}</span>
            </div>
        </div>
        <div v-else>
            <span :style="{color: textColor}">{{loaderMessage}}</span>
        </div>       
    </div>
</template>

<script>
export default {
    props:{
        loaderMessage : {
            type : String,
            default : ''
        },
        loaderStyle : {
            type : String,
            default : ''
        },
        textColor:{
            type: String,
            default: "#fff"
        },
        circleColor : {
            type : String,
            default : "#57fdf4"
        },        
    },
    name: 'loader',
}
</script>

<style lang="scss">
    .centeredLoader{
        display: flex;
        justify-content: center;
        width: 100%;

    }

    .lds-css{
        display: flex;
        justify-content: center;
        height: 100%;
        flex-direction: column;
        align-items: center;
        color: #000;
        
        span{
            padding: 10px 0;
        }
    }

    @keyframes lds-eclipse {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes lds-eclipse {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    .lds-eclipse {
        position: relative;
    }
    .lds-eclipse div {
        position: absolute;
        -webkit-animation: lds-eclipse 0.5s linear infinite;
        animation: lds-eclipse 0.5s linear infinite;
        width: 160px;
        height: 160px;
        top: 20px;
        left: 20px;
        border-radius: 50%;
        // box-shadow: 0 8px 0 0 #9d2b9a;
        -webkit-transform-origin: 80px 84px;
        transform-origin: 80px 84px;
    }
    .lds-eclipse {
        width: 50px !important;
        height: 50px !important;
        -webkit-transform: translate(-25px, -25px) scale(0.25) translate(25px, 25px);
        transform: translate(-25px, -25px) scale(0.25) translate(25px, 25px);
    }

</style>